<template>
  <div>
  	<div class="btns-wrap">
  	  <el-button type="primary" class="addBtn" @click="toIndustryCategoryClick">行业分类</el-button>
  	  <el-button type="primary" class="addBtn" @click="addBtnClick">添加案例</el-button>
  	</div>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      prop="sort"
		      label="权重"
		      align="center"
		      width="60"
        >
		    </el-table-column>
		    
		    <el-table-column
		      label="封面图片"
		      align="center"
        >
          <template slot-scope="scope">
             <img :src="imgDomain + scope.row.project_icon"  class="project-img">
          </template>
		    </el-table-column>
        <el-table-column
          prop="project_name"
          label="案例标题"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="所属类型"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.project_type === '1'">大客户案例</span>
            <span v-if="scope.row.project_type === '2'">普通案例</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="class_name"
          label="所属行业"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="添加时间"
          align="center"
          width="160"
        >
        </el-table-column>
		    <el-table-column
		      label="操作"
		      align="center"
		      width="180"
        >
         <template slot-scope="scope">
         	  <div class="operation-wrap">
         	    <span class="opration-item" @click="toEditCase(scope.row)">编辑</span>
         	    <span class="opration-item" @click="changeCaseStatus(scope.row)" v-if="scope.row.is_recommend === '1'">设为推荐</span>
              <span class="opration-item" @click="changeCaseStatus(scope.row)" v-if="scope.row.is_recommend === '2'">取消推荐</span>
         	    <span class="opration-item" @click="deleteCaseClick(scope.row)">删除</span>
         	  </div>
         </template>
		    </el-table-column>
		  </el-table>
		  <common-pagination
			  :total="total"
        :page_size="page_size"
			  @size-change="handelPagesizeChange"
			  @page-change="handlePageChange"
			></common-pagination>
    </div>
    <common-dialog
    :title="dialogTitle"
    :dialogVisible="dialogVisible"
    @cancel="dialogCancelClick"
    @confirm="dialogConfirmClick"
    @dialog-close="dialogClose"
		>
      <div class="dialog-body-wrap">
  		  <div v-if="dialogType === 'delete'">
          是否删除案例？
        </div>
        <div v-if="dialogType === 'recommend'">
          <div v-if="handle_row.is_recommend === '1'">是否设为推荐？</div>
          <div v-if="handle_row.is_recommend === '2'">是否取消推荐？</div>
        </div>
      </div>
		</common-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import CommonDialog from '@/components/CommonDialog';
import CommonPagination from '@/components/CommonPagination';
import { getCaseList, deleteCase, editCase, getCaseClass } from '@/api/case-manage';

export default {
  name: 'casemanage',
  data() {
  	return {
      tableData: [],
      dialogVisible: false,
      dialogTitle: '',
      dialogType: '',
      handle_row: {},
      page_index: '1',  //第几页
  		page_size: '10',
  		total: 0, //总条数
  	}
  },
  computed: {
  	...mapState(['imgDomain'])
  },
  mounted() {
    this._getCaseList();
    this._getCaseClass();
  },
  components: {
     CommonDialog,
     CommonPagination
  },
  methods: {
    ...mapMutations(['update_case_class']),
    async _getCaseList() {
      let postData = {
        page_index: this.page_index,
        page_size: this.page_size
      }
      const { data, status } = await getCaseList(postData);
      if ( status !== 200) return
      this.tableData = data.data;
      this.total = data.total;
      console.log( data, 'case list')
    },
    async _getCaseClass() {
      let postData = {
        page_index: '1',
        page_size: '99'
      };
      const { data, status } = await getCaseClass(postData);
      if (status !== 200) return
      //更新store数据
      this.update_case_class(data.data);
      console.log(data, 'case class')
    },
  	addBtnClick() {
      this.$router.push('/case-handle')
  	},
  	toIndustryCategoryClick() {
      this.$router.push('/industry-category')
  	},
  	dialogCancelClick() {
      this.dialogVisible = false;
  	},
  	async dialogConfirmClick() {
      if (this.dialogType === 'delete') {
        const { status } = await deleteCase(this.handle_row.id);
        if (status === 200) {
          this.dialogVisible = false
          return
        }
      }
      if (this.dialogType === 'recommend') {
        const { is_recommend } = this.handle_row;
        this.handle_row.is_recommend = is_recommend === '1' ? '2' : '1';
        const { status } = await editCase(this.handle_row);
        if ( status === 200 ) {
          this.dialogVisible = false;
        }
      }
  	},
  	dialogClose() {
      this.dialogVisible = false;
      this.handle_row = {};
      this._getCaseList();
  	},
  	handelPagesizeChange(size) {
      this.page_size = size;
      this._getCaseList()
  	},
  	handlePageChange(page) {
      this.page_index = page;
      this._getCaseList();
  	},
    deleteCaseClick(row) {
      this.handle_row = row;
      this.dialogTitle = '删除';
      this.dialogType = 'delete';
      this.dialogVisible = true;
    },
    toEditCase(row) {
      this.$router.push({
        path: '/case-handle',
        query: {
          uuid: row.id
        }
      })
    },
    changeCaseStatus(row) {
      this.handle_row = JSON.parse(JSON.stringify(row));
      this.dialogTitle = '案例推荐';
      this.dialogType = 'recommend';
      this.dialogVisible = true;
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';
.btns-wrap {
	display: flex;
	justify-content: space-between;
}
.table-wrap {
	margin-top: 40px;
  margin-bottom: 40px;
  .project-img {
    width: 100%;
    max-height: 300px;
  }
}
.operation-wrap {
	display: flex;
	justify-content: space-around;
	color: @color-text;
	.opration-item{
		cursor: pointer;
	}
}
.dialog-body-wrap {
	text-align: center;
}
/deep/.el-table__row {
  height: 200px;
}
</style>
